import { render, staticRenderFns } from "./kpiOverview.vue?vue&type=template&id=7980fe0f&scoped=true&"
import script from "./kpiOverview.vue?vue&type=script&lang=js&"
export * from "./kpiOverview.vue?vue&type=script&lang=js&"
import style0 from "./kpiOverview.vue?vue&type=style&index=0&id=7980fe0f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7980fe0f",
  null
  
)

export default component.exports